module.exports = __webpack_public_path__ + "img/homeHealthLogo.5f0e9051.png";